module.exports = __webpack_public_path__ + "static/media/cardinal-spellman.9a6b5e8a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/schools/logos/cardinal-spellman.jpg
// module id = 615
// module chunks = 0